<template>
	<div>
		<div class="authPage__text">
			<div class="authPage__title">
				<div class="authPage__titleLine1">
					{{ $t("resetPasswordTitleLine1") }}
				</div>
				<div class="authPage__titleLine2">
					{{ $t("resetPasswordTitleLine2") }}
				</div>
			</div>
			<div class="authPage__lead">
				{{
					$t(
						"Digite a password desejada no campo abaixo para criar uma nova password. Aconselhamos a guardá-lo em segurança"
					)
				}}
			</div>
		</div>

		<ValidationObserver v-slot="{ handleSubmit }">
			<form
				class="authPage__form"
				@submit.prevent="handleSubmit(handleValidSubmit)"
			>
				<div
					class="d-grid--2"
					:style="{
						'--column-gap': '20px',
						'--row-gap': '30px',
						'margin-bottom': '60px',
					}"
				>
					<div
						class="o-stack"
						:style="{
							'--gap': '20px',
						}"
					>
						<ValidationProvider
							rules="required|strong_password"
							v-slot="{ errors }"
						>
							<BFieldBlock :label="$t('Password')">
								<BFieldText
									:placeholder="$t('Insira a password')"
									type="password"
									v-model="form.password"
									:state="errors.length ? 'error' : undefined"
								/>
							</BFieldBlock>
						</ValidationProvider>

						<PasswordStrengthMeter :password="form.password" />
					</div>

					<ValidationProvider
						:rules="{
							required: true,
							is: form.password,
						}"
						v-slot="{ errors }"
					>
						<BFieldBlock :label="$t('Confirme password')">
							<BFieldText
								v-model="form.confirmPassword"
								:placeholder="$t('Repita a password')"
								type="password"
								:state="errors.length ? 'error' : undefined"
								:helperText="errors.length ? $t(errors[0]) : undefined"
							/>
						</BFieldBlock>
					</ValidationProvider>
				</div>

				<div class="authPage__mainExpandedFormFooter justify-end">
					<BBtn>
						{{ $t("Alterar password") }}
					</BBtn>
				</div>
			</form>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapActions } from "vuex";

import BIcon from "@/components/base/BIcon";
import BBtn from "@/components/base/BBtn";
import BFieldBlock from "@/components/base/BFieldBlock";
import BFieldText from "@/components/base/BFieldText";
import PasswordStrengthMeter from "./PasswordStrengthMeter";

import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
	components: {
		BIcon,
		BBtn,
		BFieldBlock,
		BFieldText,
		PasswordStrengthMeter,
		ValidationProvider,
		ValidationObserver,
	},
	data() {
		return {
			form: {
				password: "",
				confirmPassword: "",
			},
		};
	},
	methods: {
		...mapActions("user", ["resetPassword"]),
		handleValidSubmit(e) {
			this.resetPassword({
				password: this.form.password,
				confirmPassword: this.form.confirmPassword,
				userId: this.userId,
				code: this.code,
			})
				.then(() => {
					this.$notify({
						type: "success",
						title: "Password alterada com sucesso.",
					});

					this.$router.push({
						name: "Login",
					});
				})
				.catch(() => {
					this.$notify({
						type: "error",
						title: "Erro ao alterar a password.",
					});
				});
		},
	},
	created() {
		this.userId = this.$route.query.userId;
		this.code = this.$route.query.code;
	},
};
</script>
